import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import ReactDOM from 'react-dom';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid'
import MenuIcon from '@material-ui/icons/Menu';

// images
import logoimg from '../../img/logofinal.png'
import codeimage2 from "../../img/test.png";
import codeimage3 from "../../img/tabIcon.png";


const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
});

const TemporaryDrawer = () => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    left: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <div
      className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      style={{backgroundColor:'#feb13e'}}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
    <List>
      <a href="/">
        <img src={logoimg} style={{width: 70, padding:0}} />
      </a>
    </List>
    <Divider />
      <List className="Pcat---m-menu" >
        <a href="/#Feature" style={{color:'black'}}>
          Features
        </a>
        <Divider />
        <a href="/#Team" style={{color:'black'}}>
          Team
        </a>
        <Divider />
        <a href="/white-paper" style={{color:'black'}}>
          Litepaper
        </a>
        <Divider />
        <a href="/#FAQ" style={{color:'black'}}>
          F.A.Q
        </a>
        <a href="/#roadmap" style={{color:'black'}}>
          Roadmap
        </a>
        <Divider />
        <a href="/lock-lp-token" style={{color:'black'}}>
          Locker
        </a>
        <br />
          <a className="pcc-v3-3-menu_dapp_btn" href="https://exchange.pancakeswap.finance/#/swap?outputCurrency=0x41d7ca990138dddd70aef6a66cce6cf37b478428">
                <span>Buy Pcatv3 </span>
                <img src={codeimage3} className="img-fluid  ml-1"  />
          </a>
          <a className="mt-3 pcc-v3-3-menu_dapp_btn" href="/dashboard">
            <span>Claim Rewards </span>
            <img src={codeimage2} className="img-fluid ml-1" />
          </a>
      </List>
    </div>
  );

  return (
    <div className="pcc---headerMenu_mobile">
      <Container maxWidth="xl">
        <Grid
            container
            direction="row"
        >
          <Grid
              container
              direction="row"
              justify="flex-start"
              alignItems="center"
              xs="6"
          >
              <a href="#">
                <img src={logoimg} style={{width: 70}} />
              </a>
          </Grid>
          <Grid
              container
              direction="row"
              justify="flex-end"
              alignItems="center"
              xs="6"
            >
              <React.Fragment key={'left'}>
                <Button onClick={toggleDrawer('left', true)}>
                  <MenuIcon />  
                </Button>
                <Drawer anchor={'left'} open={state['left']} onClose={toggleDrawer('left', false)}>
                  {list('left')}
                </Drawer>
              </React.Fragment>
            </Grid>
        </Grid>
      </Container>
  </div>
  );
}
export default TemporaryDrawer;